// extracted by mini-css-extract-plugin
export var langLink = "lang-slug-module--langLink---SfpM";
export var langLinkHidden = "lang-slug-module--langLinkHidden--P6UBo";